// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"532":"4fffce1ecfea467ce4da","678":"07c8bad4865e36ac06cf","731":"50a6dabafe7d779dd9de","843":"4d22e4d87d98fa226c97"}[chunkId] + ".js";
};